import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DarkBg from '@/components/dark-bg.vue';
import BoxList from '@/views/review/components/review-data/box-list.vue';
import TotalProgress from '@/views/review/components/review-data/total-progress.vue';
import TotalNum from '@/views/review/components/review-data/total-num.vue';
import StartReview from '@/views/review/components/review-data/start-review.vue';
import IframeServer from '@/views/iframe-server/index';
import LookVideoDialog from '@/components/look-video-dialog.vue';
import { queryMemoryCardInfo as _queryMemoryCardInfo } from '@/api/review.js';
import { getVideoUrl } from '@/utils/guide-video';
import { getFirstGuide, guideQuery } from '@/api/modules/guide';
export default {
  name: 'ReivewData',
  components: {
    DarkBg: DarkBg,
    BoxList: BoxList,
    TotalNum: TotalNum,
    StartReview: StartReview,
    TotalProgress: TotalProgress,
    LookVideoDialog: LookVideoDialog
  },
  props: {
    subjectCode: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      boxList: [],
      progressData: {},
      showVideoDialog: false,
      dialogUrl: '',
      dialogTitle: '复习分册'
    };
  },
  watch: {
    subjectCode: {
      immediate: true,
      handler: function handler(val) {
        if (!this.subjectCode) return;
        this.queryMemoryCardInfo(); // 切换学科
      }
    }
  },
  created: function created() {
    this.isFirstToReview();
  },
  methods: {
    // 查看是否是首次进入复习页 自动播放首次复习页视频
    isFirstToReview: function isFirstToReview() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$getFirstGuide, data, status;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getFirstGuide({
                  code: 'V0002'
                });

              case 2:
                _yield$getFirstGuide = _context.sent;
                data = _yield$getFirstGuide.data;
                status = _yield$getFirstGuide.status;

                if (!(status !== 1 || !data || !data.content)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                _this.playVideo(data);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 记忆验证卡片复习 艾宾浩斯曲线是什么
    handleTip: function handleTip(type) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var param, _yield$guideQuery, data, status;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                param = {
                  codes: ['HW0002'],
                  param: {
                    'code': type === 1 ? 'C0008' : 'C0010'
                  }
                };
                _context2.next = 3;
                return guideQuery(param);

              case 3:
                _yield$guideQuery = _context2.sent;
                data = _yield$guideQuery.data;
                status = _yield$guideQuery.status;

                if (!(status !== 1 || !(data !== null && data !== void 0 && data[0]))) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return");

              case 8:
                _this2.$showModal(IframeServer, {
                  url: data[0].content,
                  iframeName: 'guide'
                }, {
                  width: '800px',
                  noFooter: true,
                  customClass: 'guide-dialog'
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 复习分册是什么
    handleVideo: function handleVideo() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var param, _yield$guideQuery2, data, status;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                param = {
                  codes: ['V0002'],
                  param: null
                };
                _context3.next = 3;
                return guideQuery(param);

              case 3:
                _yield$guideQuery2 = _context3.sent;
                data = _yield$guideQuery2.data;
                status = _yield$guideQuery2.status;

                if (!(status !== 1 || !(data !== null && data !== void 0 && data[0]))) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return");

              case 8:
                _this3.playVideo(JSON.parse(data[0].content));

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 播放视频
    playVideo: function playVideo(video) {
      this.dialogUrl = getVideoUrl(video);
      this.dialogTitle = video.videoName;
      this.showVideoDialog = true;
    },
    // 记忆验证卡片信息
    queryMemoryCardInfo: function queryMemoryCardInfo() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$_queryMemoryCa, status, data, mastered, total, percent, list;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _queryMemoryCardInfo({
                  subjectId: _this4.subjectCode
                });

              case 2:
                _yield$_queryMemoryCa = _context4.sent;
                status = _yield$_queryMemoryCa.status;
                data = _yield$_queryMemoryCa.data;

                if (!(status !== 1)) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt("return");

              case 7:
                mastered = data.mastered, total = data.total, percent = data.percent, list = data.list;
                _this4.progressData = {
                  mastered: mastered,
                  total: total,
                  percent: percent
                };
                _this4.boxList = list || [];

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};